// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1uv2C","form":"styles_form__3e32j"};